<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      show-save-button
      unit="学期"
      id-key="TermId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期编号" prop="TermNumber">
              <el-input size="mini" v-model="data.TermNumber" placeholder="请填写学期编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期名称" prop="TermName">
              <el-input size="mini" v-model="data.TermName" placeholder="请填写学期名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始时间" prop="StartTime">
              <el-date-picker
                v-model="data.StartTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="结束时间" prop="EndTime">
              <el-date-picker
                v-model="data.EndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择时间"
                style="width:100%;" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        TermId: 0,
        TermNumber: "",
        TermName: "",
        StartTime: "",
        EndTime: "",
      },
      api: require("@/api/ed/term").default,
      isMB: this.$store.state.isMB,
      rules: {
        TermNumber: [{ required: true, message: "请填写学期编号" }],
        TermName: [{ required: true, message: "请填写学期名称" }],
        StartTime: [{ required: true, message: "请选择开始时间" }],
        EndTime: [{ required: true, message: "请选择结束时间" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
    },
    onEditOpened() {
    },
  },
};
</script>
<style lang="scss">
</style>